export default "__VITE_ASSET__CIqYdq_V__"